/*
  Режим исковой давности: какая из двух посчитанных сумм уйдёт в документ.

  🔴 Переключатель, а не пара кнопок (09.09.2026). До этого здесь стояли две
  обычные кнопки, из которых текущий режим был залит цветом действия. В кабинете
  залитая кнопка везде означает «сделать», и понять, что тут она означает
  «выбрано сейчас», человеку неоткуда: он мог нажать её, думая, что подтверждает
  уже установленное, - и это решение протоколируется.

  Подпись «Сейчас: ...» словами обязательна: цвет читают не все, а последствие у
  выбора денежное - от него зависит и сумма требования, и пошлина.
*/

import { dateTime } from '../api/format.js'
import { useAccess } from './AccessContext.jsx'
import { Switch } from './Common.jsx'

const MODES = [
  { value: 'full', title: 'Весь долг' },
  { value: 'within_limitation', title: 'Только в пределах давности' },
]

export default function SettingsLimitation({ organisation, onChange, saving = false }) {
  const { readonly } = useAccess()
  const current = MODES.find((mode) => mode.value === organisation.limitation_mode)

  return (
    <>
      <p className="muted">
        Арбитр ЖКХ считает обе величины всегда. Режим определяет ту, что уйдёт в документ, а значит
        и цену требования с пошлиной. Решение принимаете вы, и оно протоколируется.
      </p>
      <Switch
        value={organisation.limitation_mode}
        // Повторное нажатие на уже выбранный режим запроса не шлёт (аудит 28.10.2026): сервер
        // тоже его не примет за смену, но и лишнего обращения незачем.
        onChange={(mode) => {
          if (mode === organisation.limitation_mode && organisation.limitation_mode_set_at) return
          onChange(mode)
        }}
        options={MODES}
        disabled={readonly || saving}
      />
      <p className="muted">
        Сейчас: {current ? current.title.toLowerCase() : 'не выбрано'}
        {organisation.limitation_mode_set_at
          ? `. Выбрано ${dateTime(organisation.limitation_mode_set_at)}`
          : ''}
      </p>
    </>
  )
}
